
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 3.75a3 3 0 106 0 3 3 0 10-6 0zm6.75 10.5V12a3.75 3.75 0 00-7.5 0v2.25h1.5l.75 6h3l.75-6zM2.25 6a2.25 2.25 0 104.5 0 2.25 2.25 0 10-4.5 0zM5.7 9.947A3.753 3.753 0 00.75 13.5v.75h1.5l.75 4.5h3l.376-2.256M17.25 6a2.25 2.25 0 104.5 0 2.25 2.25 0 10-4.5 0zm1.05 3.947a3.753 3.753 0 014.95 3.553v.75h-1.5l-.75 4.5h-3l-.376-2.256M23.25 21c0 1.243-5.037 2.25-11.25 2.25S.75 22.243.75 21","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    